'use client';

import { useEffect } from 'react';

/**
 * WebMCP (Web Model Context Protocol / Google Chrome Agentic AI 2026)
 * Registration component that registers tools directly with navigator.modelContext
 * or window.webMcp for Chrome Lighthouse Agentic Audits.
 */
export function WebMCPInitializer() {
    useEffect(() => {
        if (typeof window === 'undefined') return;

        const nav = navigator as any;
        const modelContext = nav.modelContext || (window as any).webMcp;

        if (modelContext && typeof modelContext.registerTool === 'function') {
            try {
                modelContext.registerTool({
                    name: 'search_products',
                    description: 'Przeszukiwanie i filtrowanie katalogu produktów po frazie lub nazwie',
                    inputSchema: {
                        type: 'object',
                        properties: {
                            query: { type: 'string', description: 'Szukana fraza lub nazwa produktu' }
                        },
                        required: ['query']
                    }
                });

                modelContext.registerTool({
                    name: 'subscribe_newsletter',
                    description: 'Zapis do newslettera i pobranie kodu rabatowego',
                    inputSchema: {
                        type: 'object',
                        properties: {
                            email: { type: 'string', description: 'Adres e-mail subskrybenta' }
                        },
                        required: ['email']
                    }
                });

                modelContext.registerTool({
                    name: 'add_to_cart',
                    description: 'Dodanie produktu lub wariantu do koszyka klienta',
                    inputSchema: {
                        type: 'object',
                        properties: {
                            quantity: { type: 'number', description: 'Liczba zamawianych sztuk' }
                        },
                        required: ['quantity']
                    }
                });

                modelContext.registerTool({
                    name: 'place_order',
                    description: 'Złożenie i finalizacja zamówienia w sklepie internetowym',
                    inputSchema: {
                        type: 'object',
                        properties: {
                            email: { type: 'string', description: 'Adres email zamawiającego' },
                            address: { type: 'string', description: 'Adres dostawy' },
                            city: { type: 'string', description: 'Miejscowość dostawy' },
                            postalCode: { type: 'string', description: 'Kod pocztowy' }
                        },
                        required: ['email', 'address', 'city', 'postalCode']
                    }
                });
            } catch (err) {
                console.debug('WebMCP tool registration:', err);
            }
        }
    }, []);

    return null;
}
